<template>
  <b-row
    v-if="canRead && coreCustomerId"
    class="justify-content-center m-1"
  >
    <b-button
      variant="outline-primary"
      block
      :disabled="loading"
      @click="open"
    >
      <b-spinner
        v-if="loading"
        small
      />
      <feather-icon
        v-else
        icon="MessageCircleIcon"
      />
      Abrir chat
    </b-button>
  </b-row>
</template>

<script>
import { BRow, BButton, BSpinner } from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { CUSTOMER_CHAT_RESOURCE, READ_ACTION } from '@/constants/resources'
import * as types from '../store/types'
import { CHAT_ERROR_UNAVAILABLE, CHAT_ERROR_FORBIDDEN } from '../services/staffToken'

// Botão da ficha do cliente (Profile → ProfileAbout) que abre a conversa do app MeuFuturo.
export default {
  components: {
    BRow,
    BButton,
    BSpinner,
  },
  props: {
    coreCustomerId: {
      type: [Number, String],
      default: null,
    },
  },
  setup() {
    return { toast: useToast() }
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    canRead() {
      return this.$can(READ_ACTION, CUSTOMER_CHAT_RESOURCE)
    },
  },
  methods: {
    async open() {
      this.loading = true
      try {
        const conversation = await this.$store.dispatch(types.OPEN_CONVERSATION_BY_CUSTOMER, this.coreCustomerId)
        this.$router.push({ name: 'customer-chat', query: { conversation: conversation.conversationId } })
      } catch (error) {
        this.notify(error)
      } finally {
        this.loading = false
      }
    },
    notify(error) {
      const code = error && error.code
      const status = error && error.status
      let text = 'Não foi possível abrir o chat. Tente novamente.'
      let variant = 'danger'
      // Erros do token de staff (backend-core) vêm com `code`; do chat-service, com `status`.
      if (code === CHAT_ERROR_UNAVAILABLE || status === 503) {
        text = 'O chat com clientes está indisponível no momento.'
      } else if (code === CHAT_ERROR_FORBIDDEN) {
        text = 'Você não tem permissão para acessar o chat com clientes.'
      } else if (status === 404) {
        text = 'Cliente ainda não usa o app MeuFuturo'
        variant = 'warning'
      } else if (status === 403) {
        text = 'Você não participa desta conversa'
        variant = 'warning'
      }
      this.toast({
        component: ToastificationContent,
        props: {
          title: 'Chat com clientes',
          text,
          icon: 'MessageCircleIcon',
          variant,
        },
      })
    },
  },
}
</script>
